import { SystemStyleObject } from "@chakra-ui/theme-tools";

// lock the root elements to the viewport, so any scroll behaviour must be
// implemented in the child components.
// setting `overflow: hidden` prevents any chance of double scrollbars.
export const rootStyles: SystemStyleObject = {
  html: {
    height: "100%",
    overflowX: "hidden",
  },
  body: {
    height: "100%",
    overflowY: "hidden",
    overflowX: "hidden",
  },
  "#root": {
    height: "100%",
    width: "100%",
  },
};
